import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  mainLabel: {
    fontWeight: 600,
    marginBottom: spacing(2),
    fontSize: spacing(14),
    lineHeight: '1.5',
    display: 'block',
    whiteSpace: 'normal',
    alignItems: 'center',
    color: Theme.Colors.Grayscale.OneThousand,
  },
  label: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: Theme.Colors.Grayscale.SixtyFour,
    fontSize: spacing(14),
    marginTop: '5px',
  },
  errorMessage: {
    color: Theme.Colors.Red.Base,
    marginTop: spacing(8),
    fontSize: spacing(10.5),
    fontFamily: 'Roboto',
    height: spacing(10),
    display: 'flex !important',
  },
  required: {
    color: Theme.Colors.Red.Base,
    marginLeft: spacing(4),
    display: 'inline',
  },

  checkboxContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    marginTop: 12,
  },
  checkbox: {
    padding: 0,
    marginRight: 8,
  },
  inputContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },

  input: {
    '& .MuiInputBase-root': {
      fontSize: '1.4rem',
      padding: '8px 10px',
    },
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}))
